import { PureComponent } from 'react'
import styled from 'glamorous'

import { noop } from 'lodash'
import { $ } from 'utils'


const InputContainer = styled.div({
  position: 'relative',
  width: '100%',
  marginTop: 20,
  height: 34,
  backgroundColor: 'white',
  borderRadius: 3,
  border: 'none',
  borderBottom: 'var(--border)',
})

const Input = styled.input({
  display: 'inline-block',
  position: 'absolute',
  height: '100%',
  width: '100%',
  left: 0,
  top: 0,
  textAlign: 'left',
  border: 'none',
  boxShadow: 'none',
  fontSize: 14,
  padding: '0 0 19px 0',
  '&': {
    outline: 'none !important',
    boxShadow: 'none !important'
  }
})

export default class SignInput extends PureComponent {

  static defaultProps = {
    value: '',
    placeholder: '',
    onChange: noop,
    type: 'text'
  }

  handleChange = ({ target }) =>
    this.props.onChange(target.value)

  render = () =>
    $(InputContainer,
      $(Input, {
        ...this.props,
        onChange: this.handleChange,
      })
    )
}



// WEBPACK FOOTER //
// ./src/pages/SignLayout/SignInput.js